function getPriceForCalculations(rowData) {
    return rowData.auction_type != 3
        ? rowData.current_highest_bid
        :(rowData.similar_cars_bid_min_2 !== null
            ? 1000 * rowData.similar_cars_bid_min_2
            : rowData.similar_cars_bid_median_1);
}

export function registerGlobalFunctions() {
    window.formatRiaPrice = (item, placeholder = '&mdash;') => item.calculated_price !== null
        ? `<span title="(${getPriceForCalculations(item)} + 1555 + 0.365 * (${getPriceForCalculations(item)} + 450) + x * объём * возраст) * 1.12 + 100, где x = 50 для бензина и x = 75 для дизелья">${item.calculated_price}</span>`
        : placeholder;
    window.formatMobileDePrice = (item, placeholder = '&mdash;') => item.mobile_de_calculated_price !== null
        ? `<span title="(${getPriceForCalculations(item)} + 100 + 350 + 100 + 33 + 100) * 1.19">${item.mobile_de_calculated_price}</span>`
        : placeholder;
}


// WEBPACK FOOTER //
// ./modules/car_auctions/common/global_functions.js